import React, { useEffect, useState } from "react";
import ReactTable from "react-table";
import * as notify from "../../shared/notify";

import { ButtonInput, Select } from "../form-inputs/inputs";

import { changeBinLocation, getBinHistory, getLocations } from "./lib/binData";
import { COLUMNS } from "./lib/constants";
import { useInput } from "../../shared/hooks/form-fields";

const BinMover = () => {
    const [locations, setLocations] = useState([]);
    const [binHistory, setBinHistory] = useState([]);
    const [binId, setBinId] = useState("");
    const selectLocationCode = useInput("");
    const [errorFields, setErrorFields] = useState([]);

    useEffect(() => {
        getLocationList();
    }, []);

    const getLocationList = async () => {
        const locationList = await getLocations();
        setLocations(locationList);
    };

    const updateField = (name, value) => {
        setBinId(value.trim());
    };

    const onHistoryClick = () => {
        if (!binId) {
            setErrorFields(["binId"]);
            notify.error("Please enter a bin id");

            return;
        }

        setErrorFields([]);
    };

    const searchBinInfo = async (e) => {
        if (!binId) {
            return;
        }

        const history = await getBinHistory(binId);
        setBinHistory(history);
    };

    const handleBinMove = async (e) => {
        e.preventDefault();

        const locationCode = selectLocationCode.value;
        const newErrorFields = [];

        if (!binId) {
            newErrorFields.push("binId");
            notify.error("Please enter a bin id");
        }

        if (!locationCode) {
            newErrorFields.push("location");
            notify.error("Please select a location");
        }

        if (!binId || !locationCode) {
            setErrorFields(newErrorFields);

            return;
        }

        const response = await changeBinLocation(binId, locationCode);

        if (notify.errorResponse(response)) {
            const fields = response.errors.map((err) => {
                return err.field.charAt(0).toLowerCase() + err.field.slice(1);
            });
            setErrorFields(fields);

            return;
        }

        setErrorFields([]);

        if (!response) {
            return;
        }

        if (response.wasSuccess) {
            notify.success("Saved!");

            selectLocationCode.reset();
            const history = await getBinHistory(binId);
            setBinHistory(history);
        } else {
            notify.error(response.failureReason);
        }
    };

    return (
        <div className="bin-mover">
            <div className="row">
                <div className="column -span6">
                    <ButtonInput
                        name="binId"
                        label="Bin ID"
                        value={binId}
                        updateOnChange={updateField}
                        onBlur={searchBinInfo}
                        buttonClick={onHistoryClick}
                        buttonText="History"
                        buttonClass="button"
                        invalid={errorFields.includes("binId")}
                    />
                    <Select name="location" label="New Location" options={locations} {...selectLocationCode.bind} invalid={errorFields.includes("location")} />
                    <button className="button -primary -full" onClick={handleBinMove}>
                        Move The Bin
                    </button>
                </div>
                <div className="column -span6">
                    <ReactTable data={binHistory} columns={COLUMNS} minRows="5" defaultPageSize={100} showPagination={false} style={{ maxHeight: "400px" }} />
                </div>
            </div>
        </div>
    );
};

export default BinMover;
